<template>
    <div class="step_modal">
        <div class="steps_popup">
            <div class="steps_close"><div @click="closePopup"><SvgHeaderSvg :type="'close'" class="largesvg"/></div></div>
            <div class="loader_box" v-if="loader">
                <img width="200" loading="lazy" height="200" alt="loader" src="~/assets/assets/loader.svg">
            </div>
            <div v-else class="steps_data">
                <div class="image text-center mb-3">
                    <!-- <CyoStepsSlider :images="images.images" /> -->
                     <!-- {{ images.images.side_image }} -->
                    <img width="200" height="200" :src="data?.product?.image" alt="setting image">
                </div>
                <!-- <div class="over_flow mb-3">
                    <div class="metal_flex">
                        <div class="metal_box" v-for="opt in setting_data.metals" :key="opt.id" v-show="opt.availability === 1" :class="{ 'active': opt.selected }"
                            @click="changeMetal(opt)">
                            <img v-if="opt.color==='white'" width="50" height="50" src="~/assets/metals/white.png" alt="white gold"/>
                            <img v-if="opt.color==='yellow'" width="50" height="50" src="~/assets/metals/yellow.png" alt="yellow gold"/>
                            <img v-if="opt.color==='rose'" width="50" height="50" src="~/assets/metals/rose.png" alt="rose gold"/>
                            <span>{{ opt.short_label }}</span>
                        </div>
                    </div>
                </div> -->
                <div class="text">
                    <h4 class="font-active text-center">{{ currentMetal.product_name }}</h4>
                    <h5 class="text-center">{{ $formatPrice(currentMetal.price) }}</h5>
                </div>
                <div class="ctas">
                    <div class="cta_btn" @click="changeProduct(data.product.page)">change</div>
                    <div class="cta_btn" @click="productUrl(data.product.page)">details</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const { data } = defineProps(['data'])
    const emits = defineEmits(['closePopup', 'changeProduct', 'productUrl'])

    const { $formatPrice } = useNuxtApp()
    const route = useRoute()
    const moduleSubType = route.meta.moduleSubType

    const setting_data = ref(false)
    const loader = ref(true)
    function closePopup(){
        emits('closePopup')
    }

    function changeProduct(type){
        emits('changeProduct', type)
    }

    function productUrl(type){
        emits('productUrl', type)
    }

    function changeMetal(option) {
        setting_data.value.metals.filter((met) =>{
            if(met.slug === option.slug){
                met.selected = 1
            }else{
                met.selected = 0
            }
        })
    }

  

    onMounted( async () => {
        const response = await $fetch(useCountryPath(`/config/setting/${moduleSubType}/detailbyid/${data.product.id}`))
        if(response.success){
            loader.value = false
            setting_data.value = response.data
        }
    })

    const currentMetal = computed(()=>{
        return setting_data.value && setting_data.value.metals.find((met) => met.selected == 1)
    })

    const images = computed(() => {
        return setting_data.value.all_images.find((img) =>{
            if(img.color == currentMetal.value.color){
                return img.images
            }
        })
    })
    

</script>

<style scoped>
.loader_box{
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.largesvg {
    transform: scale(1.3);
}

.over_flow{
    max-width: max-content;
    margin-left: auto;
    margin-right: auto;

}
.step_modal {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.15);
    padding: 13px;
    border-radius: 8px 8px 0 0;
    background: #fff;
    z-index: 999;
    /* min-height: 300px; */
}
h4 {
    font-size: 18px;
    color: #212529;
    line-height: 1.3;
}

h5 {
    font-size: 18px;
    color: var(--green);
    font-weight: 600;
    padding: 10px 0;
}

.ctas {
    display: flex;
    align-items: center;
    justify-content: center;
}

.cta_btn {
    border: 1px solid var(--green);
    min-width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: var(--green);
    text-transform: uppercase;
    font-size: 14px;
    margin: 0 5px;
    height: 40px;
    font-weight: 600;
}

.steps_close {
    text-align: right;
    margin-bottom: 5px;
}

.metal_flex {
    display: flex;
    align-items: flex-start;
    padding: 2% 0 0;
    gap: 20px;
    max-width: 100%;
    overflow: auto;
}

.metal_box {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 5px;

}

.metal_box span {
    color: #606060;
    font-size: 14px;
    text-transform: uppercase;
    min-width: 46px;
    display: inline-block;
    text-align: center;
}

.metal_box.active span {
    color: var(--green);
    font-weight: 600;
}
</style>